import { PageState } from 'models/PageState';
import { isProductPage } from 'models/ProductPageModel';

export const getOfferLink = (state: PageState) =>
  isProductPage(state.currentPage) ? state.currentPage.offerLink : undefined;

export const getSamples = (state: PageState) =>
  isProductPage(state.currentPage) && state.currentPage.samples ? state.currentPage.samples : [];

export const getProductUrl = (state: PageState) =>
  isProductPage(state.currentPage) ? state.currentPage.product.url : '';
